import { render, staticRenderFns } from "./RowTasa.vue?vue&type=template&id=33e84f64"
import script from "./RowTasa.vue?vue&type=script&lang=js"
export * from "./RowTasa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports